import ErrorPage from 'pages/ErrorPage';
import React, { Component, ErrorInfo } from 'react';
import { SentryService } from 'utils/SentryService';

interface Props {
  children: React.ReactNode
}

interface State {
  error: Error | null,
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { error: null }
  }

  override componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught an error: ', error, errorInfo)

    SentryService.reportError(error)

    this.setState({ error })
  }

  override render() {
    if (this.state.error) {
      return (
        <ErrorPage
          error={this.state.error}
          errorMessagePrefix="Center App Error"
        />
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary